export default [
  {
    "id": "404",
    "name": "not-found",
    "path": "/404/"
  },
  {
    "id": "404",
    "name": "internal-not-found-page",
    "path": "/error-404/"
  },
  {
    "id": "500",
    "name": "error",
    "path": "/500/"
  },
  {
    "id": "500",
    "name": "internal-error-page",
    "path": "/error-500"
  },
  {
    "id": "max-security",
    "name": "max-security",
    "path": "/estaticas/seguranca-maxima/"
  }
]
